import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
const IMG_ONE = 'https://cdn.magicpatterns.com/uploads/2A5SkFQmKdAb1yBqTEzjtg/Gemini_Generated_Image_8echa8echa8echa8.png';
const IMG_TWO = 'https://cdn.magicpatterns.com/uploads/hsUG73N88jcMXyQNCkwbFK/Gemini_Generated_Image_dmfg8xdmfg8xdmfg.png';
/**
 * Neat two-portrait arrangement of vetted virtual-assistant professionals
 * on the navy hero panel, with brand-color accent cards.
 */
export function HeroVisual() {
  return <div className="absolute inset-0 bg-navy-950 rounded-4xl border border-white/10 shadow-soft overflow-hidden p-6 lg:p-8" data-id="element-102">
      {/* Brand glow accents */}
      <div className="absolute -top-16 -right-12 w-72 h-72 bg-brand-gradient rounded-full blur-3xl opacity-25 pointer-events-none" data-id="element-103" />
      <div className="absolute -bottom-16 -left-12 w-64 h-64 bg-pink rounded-full blur-3xl opacity-15 pointer-events-none" data-id="element-104" />

      <div className="relative h-full grid grid-cols-5 grid-rows-6 gap-4" data-id="element-105">
        {/* Primary portrait */}
        <motion.figure initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} className="col-span-3 row-span-6 relative rounded-3xl overflow-hidden shadow-soft-lg ring-1 ring-white/10" data-id="element-106">
          <img src={IMG_ONE} alt="Malena L., Executive Assistant from Argentina" className="w-full h-full object-cover" data-id="element-107" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-950/85 via-navy-950/10 to-transparent" data-id="element-108" />
          <figcaption className="absolute bottom-0 left-0 right-0 p-4" data-id="element-109">
            <div className="text-base font-bold text-white leading-tight" data-id="element-110">
              Malena L.
            </div>
            <div className="text-xs font-medium text-pink leading-tight" data-id="element-111">
              <span className="font-bold" data-id="element-112">Argentina</span> · Executive Assistant
            </div>
          </figcaption>
        </motion.figure>

        {/* Secondary portrait */}
        <motion.figure initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.34,
        ease: 'easeOut'
      }} className="col-span-2 row-span-4 row-start-3 relative rounded-3xl overflow-hidden shadow-soft-lg ring-1 ring-white/10 translate-y-2" data-id="element-113">
          <img src={IMG_TWO} alt="Fernanda C., Brand Manager from Mexico" className="w-full h-full object-cover" data-id="element-114" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-950/85 via-navy-950/10 to-transparent" data-id="element-115" />
          <figcaption className="absolute bottom-0 left-0 right-0 p-3" data-id="element-116">
            <div className="text-sm font-bold text-white leading-tight" data-id="element-117">
              Fernanda C.
            </div>
            <div className="text-[11px] font-medium text-pink leading-tight" data-id="element-118">
              <span className="font-bold" data-id="element-119">Mexico</span> · Brand Manager
            </div>
          </figcaption>
        </motion.figure>
      </div>

      {/* Floating accent: vetted badge */}
      <motion.div className="absolute top-4 right-4 lg:top-5 lg:right-5 bg-white px-3 py-2 rounded-2xl shadow-soft-lg flex items-center gap-2 z-20" animate={{
      y: [0, -8, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-120">
        <div className="w-8 h-8 rounded-full bg-brand-gradient-soft flex items-center justify-center" data-id="element-121">
          <CheckCircle2 className="w-4 h-4 text-purple" data-id="element-122" />
        </div>
        <div className="leading-tight" data-id="element-123">
          <div className="text-[10px] text-slate-500 font-medium" data-id="element-124">
            Carefully
          </div>
          <div className="text-xs font-bold text-navy" data-id="element-125">Vetted Talent</div>
        </div>
      </motion.div>

      {/* Floating accent: rating */}
      <motion.div className="absolute bottom-6 right-6 bg-white px-3 py-2 rounded-2xl shadow-soft-lg flex items-center gap-2 z-20" animate={{
      y: [0, 8, 0]
    }} transition={{
      duration: 4.5,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.8
    }} data-id="element-126">
        <div className="flex -space-x-0.5" data-id="element-127">
          {[...Array(5)].map((_, s) => <Star key={s} className="w-3.5 h-3.5 fill-coral text-coral" data-id="element-128" />)}
        </div>
        <div className="text-xs font-bold text-navy" data-id="element-129">English-Fluent</div>
      </motion.div>
    </div>;
}